import { PODEmailPCDTypeName } from "./PODEmailPCD";
export function isPODEmailPCD(pcd) {
    return pcd.type === PODEmailPCDTypeName;
}
